import type { ColumnDef } from "@tanstack/react-table";

const BOM = String.fromCharCode(0xfeff);

/**
 * CSV sem dependência externa. BOM (via String.fromCharCode, nunca o caractere
 * Unicode cru no código-fonte — dispara no-irregular-whitespace) + separador
 * ";" para o Excel pt-BR abrir corretamente. Só suporta colunas com
 * `accessorKey` string (o caso comum das telas de consulta) — colunas
 * puramente computadas (`cell`-only) são ignoradas no export, já que não têm
 * um valor "cru" óbvio.
 *
 * Escopo "página atual" apenas (o legado, via tableExport.js, faz o mesmo — só
 * exporta o que está renderizado). Exportar todas as páginas é uma melhoria
 * possível mais tarde (refazer a query com size = totalElements), não feita
 * aqui por enquanto não ter sido pedida.
 */
export function exportRowsToCsv<T>(filename: string, columns: ColumnDef<T, unknown>[], rows: T[]): void {
  const exportable = columns.filter(
    (c): c is ColumnDef<T, unknown> & { accessorKey: string } => typeof (c as { accessorKey?: unknown }).accessorKey === "string",
  );

  const headerLine = exportable.map((c) => csvCell(String(c.header ?? c.accessorKey))).join(";");
  const lines = rows.map((row) =>
    exportable.map((c) => csvCell(String((row as Record<string, unknown>)[c.accessorKey] ?? ""))).join(";"),
  );

  const csv = BOM + [headerLine, ...lines].join("\r\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}-${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

function csvCell(value: string): string {
  return `"${value.replace(/"/g, '""')}"`;
}
